module.exports = __webpack_public_path__ + "static/img/4.09b75b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/4.png
// module id = LwXH
// module chunks = 0